import { AppService } from '../app.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnergyGroupModel } from '../models/energyGroup.model';

@Injectable()
export class EnergyGroupService extends AppService<EnergyGroupModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async getAll(companyId: string, daysOfResume: number) {

    const filters = `localClienteId=${companyId}&daysOfResume=${daysOfResume}`;
    const result = await this.getAllAsync(`GrupoEnergetico?` + filters);
    return result;
  }

  async get(dependentId: string, daysOfResume: number) {
    const filters = `daysOfResume=${daysOfResume}`;
    const result = await this.getAllAsync(`GrupoEnergetico/${dependentId}?` + filters);
    return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/energy-group.service.ts